module.exports = __webpack_public_path__ + "static/img/hsteel.1ead73e.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/hsteel.png
// module id = oFj2
// module chunks = 0